// React
import React, { useEffect, useState } from "react"
import { Link} from "react-router-dom";
import { useNavigate } from "react-router-dom"
// import jwtDecode from "jwt-decode"
// Hooks and Redux
import { useAppSelector } from '../../../redux/hooks';

import {
  PDFDocument,
  PDFTextField,
  PDFCheckBox,
  PDFRadioGroup,
  PDFDropdown,
} from "pdf-lib"

// MUI Components
import { Box, Button, Grid, Typography } from "@mui/material"
import {
  GridCellParams,
  GridColDef,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarFilterButton,
  DataGrid,
  enUS,
} from "@mui/x-data-grid"
import Icon from "@mui/material/Icon"
import Tooltip from "@mui/material/Tooltip"
import dayjs from "dayjs"

// Styles
import theme from "../../../styles/theme"
import CircularProgress from "@mui/material/CircularProgress"
import Swal from "sweetalert2"
import { thTHGrid } from "../../../@types/DataGridLocaleText"

// MUI Components
import Chip from "@mui/material/Chip"

// Utils
import { useTranslation } from "react-i18next"
import { validateMicrosoftFile } from "../../../utils"

import { getAllEmploymentContract } from "../../../services/EmployeeContractService"
import {
  getAllDocuments,
  getDocumentsfile,
  // getDocumentsfileDownload,
  sendFilesDocuments,
} from "../../../services/UserService"

import RoleType from "../../../@types/RoleType"

const EmployeeContract = () => {
  const { t, i18n } = useTranslation()
  const navigate = useNavigate()

  const userRoleType = useAppSelector((state) => state.user.roletype)
  const [loadingUpload, setLoadingUpload] = useState<boolean>(true)
  const [contractList, setContractList] = useState<any | null>([])
  const [LoadingContractList, setLoadingContractList] = useState<boolean>(true)

  const [extractedFields, setExtractedFields] = useState({})
  const [pdfText, setPdfText] = useState("")
  const [error, setError] = useState("")
  const [downloadUrl, setDownloadUrl] = useState<string | null>(null)

  const debugBase64 = (base64URL: string) => {
    let win = window.open()
    win?.document.write(
      '<iframe src="' +
        base64URL +
        '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
    )
  }

  useEffect(() => {
    const fetchAllEmploymentContract = async () => {
      try {
        const response = await getAllEmploymentContract("AllStatus")
        if (
          response?.data?.success &&
          response?.data?.data &&
          response?.data?.data.length > 0
        ) {
          const data = response?.data?.data
          let newDocuments = []
          // []

          // for (let item in data) {
          //   const base64Data = await getDocumentsfile(
          //     data[item].dmsFileId,
          //     "contract"
          //   )
          //   if (base64Data.status === 200) {
          //     newDocuments.push({
          //       id: data[item].id,
          //       dmsFileId: data[item].dmsFileId,
          //       is_active: data[item].is_active,
          //       name: data[item].name,
          //       nameFile: data[item].nameFile,
          //       type: data[item].type,
          //       created_date: data[item].created_date,
          //       created_by: data[item].created_by,
          //       // employer: `${data[item]?.emplist?.first_name_th}  ${data[item]?.emplist?.last_name_th}`,
          //       // file: {
          //       //   dataPath: base64Data?.data,
          //       //   name: data[item].name,
          //       //   type: data[item].type,
          //       // },
          //     })
          //   }
          // }
          setContractList(data)
          data.length > 0 ? setLoadingUpload(false) : setLoadingUpload(true)
        } else {
          setLoadingUpload(false)
        }
      } catch (error) {
        console.log(error)
        navigate("/servererror", { replace: true })
      } finally {
        setLoadingContractList(false)
      }
    }

    fetchAllEmploymentContract()
  }, [navigate])

  const columns: GridColDef[] = [
    {
      field: "edit",
      headerName: `${t("Edit")}`,
      headerAlign: "center",
      align: "center",
      hideSortIcons: true,
      disableColumnMenu: true,
      filterable: false,
      width: userRoleType === RoleType.Super_Admin ? 80 : 0,
      renderCell: (params) => {
        if (userRoleType === RoleType.Super_Admin) {
          return (
            <Link
              to={`/admin/contract/edit/${params.row.id}`}
              style={{
                marginLeft: 10,
                cursor: "pointer",
                color: theme.palette.button.main,
              }}
            >
              <Tooltip title={t("Edit")}>
                <Icon fontSize="medium">edit</Icon>
              </Tooltip>
            </Link>
          )
        }
      },
    },
    {
      field: "is_active",
      headerName: `${t("Status")}`,
      headerAlign: "center",
      width: 120,
      hideSortIcons: true,
      disableColumnMenu: true,
      filterable: false,
      sortable: false,
      pinnable: true,
      renderCell: (params: GridCellParams) =>
        params.row.is_active === true ? (
          <Chip
            variant="outlined"
            color="success"
            label={t("Active")}
            size="small"
          />
        ) : (
          <Chip
            variant="outlined"
            color="warning"
            label={t("Inactive")}
            size="small"
          />
        ),
    },
    {
      field: "nameFile",
      headerName: `${t("text_nameFile")}`,
      width: 300,
      valueGetter: (params: GridCellParams) => params.row.nameFile,
      renderCell: (params: GridCellParams) => params.row.nameFile ?? "-",
    },
    // {
    //   field: "dmsFileId",
    //   headerName: `${t("text_file_dms")}`,
    //   width: 300,
    //   valueGetter: (params: GridCellParams) => params.row.dmsFileId,
    //   renderCell: (params: GridCellParams) => {
    //     const fileId = params.row.dmsFileId
    //     const dataPath = params.row.file.dataPath
    //     const fileName = params.row.file.name || params.row.name
    //     const isMicrosoftFile = validateMicrosoftFile(fileName)

    //     if (fileId && dataPath) {
    //       if (isMicrosoftFile) {
    //         return (
    //           <a href={dataPath} download={fileName}>
    //             {fileName}
    //           </a>
    //         )
    //       } else {
    //         return (
    //           // eslint-disable-next-line jsx-a11y/anchor-is-valid
    //           <a
    //             onClick={() => debugBase64(dataPath)}
    //             style={{ cursor: "pointer" }}
    //           >
    //             {fileName}
    //           </a>
    //         )
    //       }
    //     }

    //     return fileId || "-"
    //   },
    // },
    {
      field: "created_date",
      headerName: `${t("Created date")}`,
      width: 150,
      valueGetter: (params: GridCellParams) =>
        Date.parse(params.row.exported_date),
      renderCell: (params: GridCellParams) =>
        typeof params.row.created_date === "string"
          ? dayjs(params.row.created_date).format("DD/MM/YYYY HH:mm")
          : "-",
    },
    {
      field: "created_by",
      headerName: `${t("Created By")}`,
      width: 150,
      valueGetter: (params: GridCellParams) => params.row.created_by,
      renderCell: (params: GridCellParams) => params.row.created_by ?? "-",
    },
  ]

  // NOTE: CustomToolbar — ซ้ำกันทุกหน้าที่มี DataGrid (37+ ไฟล์) ควรย้ายไปรวมใน components/common/DataGridToolbar.tsx
  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
      </GridToolbarContainer>
    )
  }

  return (
    // <div>
    //   {!LoadingContractList ? (
    //     <Box display="flex" justifyContent="center" gap={2}>
    //       <CircularProgress color="success" size={20} />
    //       <Typography align="center">{t("Loading")}...</Typography>
    //     </Box>
    //   ) : (
    <div>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: "70px",
        }}
      >
        <Grid
          container
          spacing={2}
          sx={{ width: "100%", alignItems: "center" }}
        >
          <Grid item xs={12} lg={9}>
            <Typography
              variant="h4"
              sx={{ fontWeight: "bold", textAlign: "left" }}
            >
              {t("title_text_employee_contract")}
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            lg={3}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <Button
              variant="contained"
              disableElevation
              sx={{
                backgroundColor: "#43a047",
                color: "white",
                "&:hover": {
                  backgroundColor: "rgb(46, 112, 49)",
                },
                minWidth: "fit-content",
                minHeight: "42px",
              }}
              component={Link}
              to="/admin/contract/create"
            >
              {t("add_btn_EmployeeContract")}
            </Button>
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ width: "100%", marginTop: 3, paddingX: 3 }}>
        {loadingUpload ? (
          <Box display="flex" justifyContent="center" gap={2}>
            {/* <Typography align="center">{t("Loading")}...</Typography> */}
            {/* <CircularProgress size={100} /> */}
            <CircularProgress color="success" size={20} />
            <Typography align="center">{t("Loading")}...</Typography>
          </Box>
        ) : contractList.length === 0 ? (
          <Typography align="center">{t("No data")}</Typography>
        ) : (
          <>
            <Box display="inline-grid" sx={{ width: "100%" }}>
              <DataGrid
                getRowId={(row) => row.id}
                rows={contractList}
                columns={columns}
                initialState={{
                  pagination: {
                    paginationModel: { page: 0, pageSize: 10 },
                  },
                }}
                pagination
                pageSizeOptions={[10, 20, 30, 40, 50]}
                getRowHeight={() => 50}
                disableRowSelectionOnClick
                sx={{
                  "&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus, &.MuiDataGrid-root .MuiDataGrid-cell:focus":
                    {
                      outline: "none !important",
                    },
                  fontSize: 13,
                }}
                slots={{
                  toolbar: CustomToolbar,
                }}
                slotProps={{
                  filterPanel: {
                    filterFormProps: {
                      logicOperatorInputProps: {
                        variant: "outlined",
                        size: "small",
                      },
                      columnInputProps: {
                        variant: "outlined",
                        size: "small",
                        sx: { mt: "auto" },
                      },
                      operatorInputProps: {
                        variant: "outlined",
                        size: "small",
                        sx: { mt: "auto" },
                      },
                      valueInputProps: {
                        InputComponentProps: {
                          variant: "outlined",
                          size: "small",
                        },
                      },
                      deleteIconProps: {
                        sx: {
                          "& .MuiSvgIcon-root": { color: "#d32f2f" },
                        },
                      },
                    },
                    sx: {
                      "& .MuiDataGrid-filterForm": { p: 2 },
                      "& .MuiDataGrid-filterForm:nth-of-type(even)": {
                        backgroundColor: () =>
                          theme.palette.mode === "dark" ? "#444" : "#f5f5f5",
                      },
                      "& .MuiDataGrid-filterFormLogicOperatorInput": {
                        mr: 2,
                      },
                      "& .MuiDataGrid-filterFormColumnInput": {
                        mr: 2,
                        width: 150,
                      },
                      "& .MuiDataGrid-filterFormOperatorInput": { mr: 2 },
                      "& .MuiDataGrid-filterFormValueInput": { width: 200 },
                    },
                  },
                }}
                localeText={
                  i18n.language === "en"
                    ? enUS.components.MuiDataGrid.defaultProps.localeText
                    : thTHGrid
                }
                // unstable_headerFilters
              />
            </Box>
          </>
        )}
      </Box>
    </div>
    //   )}
    // </div>
  )
}

export default EmployeeContract